import { keepPreviousData, useQuery } from "@tanstack/react-query";
import * as Immutable from "immutable";
import PaginationURL from "util/PaginationURL";
import { qualifyUrl } from "util/URLUtils";
import ApiRoutes from "routing/ApiRoutes";
import fetch from "logic/rest/FetchProvider";
import { defaultOnError } from "util/conditional/onError";
export const KEY_PREFIX = ["streams", "output", "filters"];
export const keyFn = (streamId, destinationType, pagination) => [
  ...KEY_PREFIX,
  streamId,
  destinationType != null ? destinationType : "all",
  pagination
];
const defaultParams = { page: 1, perPage: 10, query: "" };
export const fetchStreamOutputFilters = async (streamId, pagination) => {
  const url = PaginationURL(
    ApiRoutes.StreamOutputFilterRuleApiController.get(streamId).url,
    pagination.page,
    pagination.perPage,
    pagination.query
  );
  return fetch("GET", qualifyUrl(url)).then((response) => {
    const { elements, query, total, page, per_page: perPage, count } = response;
    return {
      list: Immutable.List(elements),
      attributes: [],
      pagination: {
        total,
        page,
        perPage,
        query,
        count
      }
    };
  });
};
const useStreamOutputFilters = (streamId, destinationType, pagination = defaultParams) => {
  const { data, refetch, isLoading, isSuccess } = useQuery({
    queryKey: keyFn(streamId, destinationType, pagination),
    queryFn: () => defaultOnError(
      fetchStreamOutputFilters(streamId, {
        ...pagination,
        query: destinationType ? `destination_type:${destinationType}` : pagination.query
      }),
      "Loading stream output filters failed with status",
      "Could not load stream output filters"
    ),
    placeholderData: keepPreviousData
  });
  return {
    data,
    refetch,
    isLoading,
    isSuccess
  };
};
export default useStreamOutputFilters;
